import React, { useEffect, useState } from 'react';
import "./Timeline.css";
import TweetBox from './TweetBox';
import Post from './Post';
import db from "../../firebase";
import { collection, onSnapshot, orderBy, query} from "firebase/firestore";
import { motion, AnimatePresence } from 'framer-motion';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fab from '@mui/material/Fab';
import Widgets from '../widget/Widgets';

const Timeline = () => {
  const [posts, setPosts] = useState([]);
  const [showWidgets, setShowWidgets] = useState(false);
  
  useEffect(()=>{
    const postData = collection(db, "posts");
    const q = query(postData, orderBy("timestamp", "desc"));
    onSnapshot(q, (querySnapshot)=>{
      setPosts(querySnapshot.docs.map((doc)=>doc.data()))
    });
  }, []);

  useEffect(() => {
    // Widgetsが表示/非表示切り替わった時にTwitterウィジェットを再読み込み
    if (showWidgets) {
      if (window.twttr) {
        window.twttr.widgets.load();
      }
    }
  }, [showWidgets]);

  const toggleWidgets = () => {
    setShowWidgets(!showWidgets);
  };

  return (
    <div className='timeline'>
      <div className='timeline--header'>
        <h2>ホーム</h2>
      </div>

      <TweetBox />

      <AnimatePresence>
        {posts.map((post)=>(
          <motion.div
            key={post.text}
            initial={{opacity:0, rotateY: -90, x: -50}}
            animate={{opacity:1, rotateY: 0, x: 0}}
            exit={{opacity:0, rotateY: 90, x: 50}}
            transition={{
              duration: 0.6,
              ease:[0.16, 1, 0.3, 1],
              rotateY: {duration: 0.6}
            }}
            style={{transformOrigin: "left center", perspective: 1000}}
          >
            <Post
              displayName={post.displayName}
              username={post.username}
              verified={post.verified}
              text={post.text}
              avatar={post.avatar}
              image={post.image}
            />
          </motion.div>
        ))}
      </AnimatePresence>

      {/* Widgetsコンポーネント */}
      <motion.div 
        className={`widgets-mobile ${showWidgets ? 'active' : ''}`}
        initial={{ y: "100%" }}
        animate={{ y: showWidgets ? 0 : "100%" }}
        transition={{ duration: 0.3 }}
      >
        <div className="widgets-mobile-content">
          <Widgets />
        </div>
      </motion.div>

      {/* ウィジェット開閉ボタン */}
      <Fab 
        color="primary" 
        size="medium"
        className="widgets-toggle-button"
        onClick={toggleWidgets}
        aria-label="toggle widgets"
      >
        {showWidgets ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </Fab>
    </div>
  );
};

export default Timeline;
